import { atom } from 'jotai';
import GlobalStore from '@store/globalStore';

export const haveTopNavbar = atom(false);
export const haveBottomNavbar = atom(false);
export const haveBackButton = atom(false);
export const haveSubjectMenu = atom(false);
export const haveTitle = atom(false);
export const haveFullLogo = atom(false);
export const haveLogoutButton = atom(false);
export const haveAccountSection = atom(false);
export const haveParentSubjectMenu = atom(false);
export const titleName = atom('');
export const haveSearchButton = atom(false);
export const isSearching = atom(false);
export const haveSkillLevelInfo = atom(false);
export const haveBottomSheet = atom(false);
export const isBottomSheetVisible = atom(false);

export const NavbarState = atom(get => {
  return {
    haveTopNavbar: get(haveTopNavbar),
    haveBottomNavbar: get(haveBottomNavbar),
    haveBackButton: get(haveBackButton),
    haveSubjectMenu: get(haveSubjectMenu),
    haveTitle: get(haveTitle),
    haveFullLogo: get(haveFullLogo),
    haveLogoutButton: get(haveLogoutButton),
    haveAccountSection: get(haveAccountSection),
    haveParentSubjectMenu: get(haveParentSubjectMenu),
    haveSearchButton: get(haveSearchButton),
    isSearching: get(isSearching),
    titleName: get(titleName),
    haveSkillLevelInfo: get(haveSkillLevelInfo),
    haveBottomSheet: get(haveBottomSheet),
    isBottomSheetVisible: get(isBottomSheetVisible),
  };
});

export function resetToDefaultNavbarState() {
  GlobalStore.set(haveTopNavbar, true);
  GlobalStore.set(haveBottomNavbar, true);
  GlobalStore.set(haveBackButton, false);
  GlobalStore.set(haveSubjectMenu, true);
  GlobalStore.set(haveTitle, false);
  GlobalStore.set(haveFullLogo, false);
  GlobalStore.set(haveLogoutButton, false);
  GlobalStore.set(haveAccountSection, true);
  GlobalStore.set(haveParentSubjectMenu, false);
  GlobalStore.set(haveSearchButton, false);
  GlobalStore.set(isSearching, false);
  GlobalStore.set(titleName, '');
  GlobalStore.set(haveSkillLevelInfo, false);
  GlobalStore.set(haveBottomSheet, false);
  GlobalStore.set(isBottomSheetVisible, false);
}

export function setNavbarWithTitleNoTopNavbar(title: string) {
  GlobalStore.set(haveTopNavbar, false);
  GlobalStore.set(haveSubjectMenu, false);
  GlobalStore.set(haveTitle, true);
  GlobalStore.set(titleName, title);
  GlobalStore.set(haveFullLogo, true);
  GlobalStore.set(haveBackButton, true);
}

export function setNavbarWithTitleWithTopNavbar(title: string) {
  GlobalStore.set(haveTopNavbar, true);
  GlobalStore.set(haveSubjectMenu, true);
  GlobalStore.set(haveTitle, true);
  GlobalStore.set(titleName, title);
  GlobalStore.set(haveFullLogo, false);
  GlobalStore.set(haveBackButton, true);
  GlobalStore.set(haveSearchButton, false);
}

// reset to default state at start
resetToDefaultNavbarState();
